"use strict";
// Copyright (c) StrangeBee 2024
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToSearchQuery = exports.convertSortOptions = exports.getDateRange = exports.parseValue = void 0;
const parseValue = (type, value) => {
    let valueProc = value;
    if (type === 'float') {
        valueProc = parseFloat(value);
    }
    else if (['number', 'integer'].includes(type)) {
        valueProc = parseInt(value);
    }
    return valueProc !== null && valueProc !== void 0 ? valueProc : '';
};
exports.parseValue = parseValue;
const getDateRange = (operator = '', from, to) => {
    function setStartOfDay(d = new Date()) {
        d.setHours(0, 0, 0, 0);
        return d;
    }
    function setEndOfDay(d = new Date()) {
        d.setHours(23, 59, 59, 999);
        return d;
    }
    function subtractDays(days, d = new Date()) {
        return new Date(d.getTime() - days * 1000 * 60 * 60 * 24);
    }
    function subtractMonths(months, date = new Date()) {
        const t = new Date(date.getTime());
        t.setMonth(date.getMonth() - months);
        return t;
    }
    if (operator == 'today')
        return [setStartOfDay().getTime(), setEndOfDay().getTime()];
    if (operator == 'last7days')
        return [setStartOfDay(subtractDays(7)).getTime(), setEndOfDay().getTime()];
    if (operator == 'last30days')
        return [setStartOfDay(subtractDays(30)).getTime(), setEndOfDay().getTime()];
    if (operator == 'last3months')
        return [setStartOfDay(subtractMonths(3)).getTime(), setEndOfDay().getTime()];
    if (operator == 'last6months')
        return [setStartOfDay(subtractMonths(6)).getTime(), setEndOfDay().getTime()];
    if (operator == 'lastyear')
        return [setStartOfDay(subtractMonths(12)).getTime(), setEndOfDay().getTime()];
    return [from, to];
};
exports.getDateRange = getDateRange;
const operator = (operatorName) => (args) => ({
    [operatorName]: args,
});
const _contains = operator('_contains');
const _or = operator('_or');
const _and = operator('_and');
const _not = operator('_not');
const _lt = operator('_lt');
const _lte = operator('_lte');
const _like = operator('_like');
const _gt = operator('_gt');
const _gte = operator('_gte');
const _in = operator('_in');
const formatField = (_field, _value, indexType, params) => {
    const propName = Array.isArray(_value) ? '_values' : '_value';
    const obj = {
        _field,
        [propName]: _value,
    };
    if (indexType === 'fulltext' && !(params === null || params === void 0 ? void 0 : params.strict)) {
        return {
            _like: obj,
        };
    }
    if (indexType === 'fulltextOnly' && !(params === null || params === void 0 ? void 0 : params.strict)) {
        return {
            _match: obj,
        };
    }
    return obj;
};
const convertSortOptions = (option) => {
    if (!'+-'.includes(option[0])) {
        return undefined;
    }
    const sign = option[0] === '+' ? 'asc' : 'desc';
    return { [option.substr(1)]: sign };
};
exports.convertSortOptions = convertSortOptions;
const formatBetween = (_field, _from, _to) => ({ _between: { _field, _from, _to } });
const convertToSearchQuery = (searchForm = [], filterQuery = false, describeField) => {
    const filters = searchForm.map((entry) => {
        var _a, _b;
        let operatorSign = null;
        if (entry.type === 'date') {
            const { values: valuesCustom = [0, 0] } = entry || {};
            const values = (0, exports.getDateRange)(entry.operator, valuesCustom[0], valuesCustom[1]);
            return formatBetween(entry.field, values[0], values[1]);
        }
        const valuesProcessed = (entry.values !== undefined && (typeof entry.values !== 'object' ? [entry.values] : entry.values)) || [];
        switch (entry.operator) {
            case 'is empty':
                return _not(_contains(entry.field));
            case 'is not empty':
                return _contains(entry.field);
            case 'any':
                operatorSign = _or;
                break;
            case 'all':
                operatorSign = _and;
                break;
            case 'like':
                return _like(formatField(entry.field, (0, exports.parseValue)(entry.type, valuesProcessed[0])));
            case 'contains':
                return _contains((0, exports.parseValue)(entry.type, valuesProcessed[0]));
            case 'not':
                return valuesProcessed.length > 1
                    ? _not(_or(valuesProcessed.map((value) => {
                        var _a;
                        return formatField(entry.field, (0, exports.parseValue)(entry.type, value), (_a = entry.describeAttribute) === null || _a === void 0 ? void 0 : _a.indexType, entry.params);
                    })))
                    : _not(formatField(entry.field, (0, exports.parseValue)(entry.type, valuesProcessed[0]), (_a = entry.describeAttribute) === null || _a === void 0 ? void 0 : _a.indexType, entry.params));
            case 'lt':
                return _lt(formatField(entry.field, (0, exports.parseValue)(entry.type, valuesProcessed[0])));
            case 'lte':
                return _lte(formatField(entry.field, (0, exports.parseValue)(entry.type, valuesProcessed[0])));
            case 'gt':
                return _gt(formatField(entry.field, (0, exports.parseValue)(entry.type, valuesProcessed[0])));
            case 'gte':
                return _gte(formatField(entry.field, (0, exports.parseValue)(entry.type, valuesProcessed[0])));
            case 'true':
                return formatField(entry.field, true);
            case 'false':
                return formatField(entry.field, false);
            case 'in':
                return _in(formatField(entry.field, entry.values));
        }
        const describeAttribute = describeField === null || describeField === void 0 ? void 0 : describeField.attributes.find(({ name }) => name === entry.field);
        if (operatorSign && valuesProcessed.length > 1) {
            return operatorSign(valuesProcessed.map((value) => {
                var _a;
                return formatField(entry.field, (0, exports.parseValue)(entry.type, value), ((_a = entry.describeAttribute) === null || _a === void 0 ? void 0 : _a.indexType) || (describeAttribute === null || describeAttribute === void 0 ? void 0 : describeAttribute.indexType), entry.params);
            }));
        }
        if (valuesProcessed.length > 0) {
            return formatField(entry.field, (0, exports.parseValue)(entry.type, valuesProcessed[0]), ((_b = entry.describeAttribute) === null || _b === void 0 ? void 0 : _b.indexType) || (describeAttribute === null || describeAttribute === void 0 ? void 0 : describeAttribute.indexType), entry.params);
        }
        return {};
    });
    if (filterQuery) {
        return filters.length > 2 ? _and([_and([...filters])]) : _and([...filters]);
    }
    const query = {
        query: _and([...filters]),
    };
    return query;
};
exports.convertToSearchQuery = convertToSearchQuery;
